<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0 ml-2">
        Developer Email
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!developerEmailFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-btn
            :disabled="
              loading ||
              (uiCtrl && !uiCtrl.isEnable('btn:::webhook:developer:create'))
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddDeveloperEmailForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่ม
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :search="search"
      :headers="headers"
      :items="developerEmails"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn
          :disabled="
            uiCtrl && !uiCtrl.isEnable('btn:::webhook:developer:delete')
          "
          icon
          @click.stop="onDelete(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <DeveloperEmailForm
      :formShow="developerEmailFormShow"
      :formAction="developerEmailFormAction"
      :developerEmail="developerEmail"
      :developerEmailInit="developerEmailInit"
      @isDeveloperEmailDataChange="handleDeveloperEmailFormDataChange"
      @formActionCompleted="handleDeveloperEmailFormActionCompleted"
      @onReset="handleDeveloperEmailFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="developerEmailFormShow && developerEmailFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DeveloperEmailForm from '@/views/webhook/DeveloperEmailForm.vue'

export default {
  components: {
    DeveloperEmailForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['email'],
      sortDesc: [false],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      headers: [
        { text: 'Email Address', value: 'email' },
        { text: '', align: 'right', sortable: false, value: 'actions' },
      ],
      developerEmailFormShow: false,
      developerEmailFormAction: '',
      developerEmail: {},
      developerEmailInit: {},
      isDeveloperEmailDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    developerEmails() {
      return this.$store.state.webhook.developerEmails
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'Developer Email',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchWebhookDeveloperEmails: 'webhook/fetchWebhookDeveloperEmails',
      deleteWebhookDeveloperEmail: 'webhook/deleteWebhookDeveloperEmail',
    }),
    onDelete(item) {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ Developer Email',
        value: item.email,
        item,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(item) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDialogDeleteLoading = true

        const payload = {
          company_uuid,
          developer_uuid: item.developer_uuid,
        }

        await this.deleteWebhookDeveloperEmail(payload)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false
      }
    },
    classRowSelected(row) {
      if (this.developerEmail.developer_uuid === row.developer_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::webhook:developer:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.developerEmail.developer_uuid === row.developer_uuid) {
        this.developerEmailFormShow = false
        this.developerEmailFormAction = ''
        this.developerEmail = {}
        this.developerEmailInit = {}
      } else {
        this.developerEmailFormShow = true
        this.developerEmailFormAction = 'edit'
        this.developerEmail = { ...row }
        this.developerEmailInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isDeveloperEmailDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddDeveloperEmailForm() {
      this.developerEmailFormShow = true
      this.developerEmailFormAction = 'add'
      this.developerEmail = {}
      this.developerEmailInit = {}
    },
    handleDeveloperEmailFormDataChange(value) {
      this.isDeveloperEmailDataChange = value
    },
    handleDeveloperEmailFormReset(formAction) {
      this.developerEmail = {}
      this.developerEmailInit = {}
      this.developerEmailFormShow = false
      this.developerEmailFormAction = ''
    },
    handleDeveloperEmailFormActionCompleted(formAction) {
      this.developerEmail = {}
      this.developerEmailInit = {}
      this.developerEmailFormShow = false
      this.developerEmailFormAction = ''
    },
    async loadData() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
        }

        this.loading = true
        await this.fetchWebhookDeveloperEmails(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.developerEmailFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDeveloperEmailDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
